
const restGet = async (url) => {
	//throw new Error("restGet is deprecated. Use restPost instead.");
	console.log(url)
	const res = await fetch(url);
	return {
		status: res.status,
		json: async () => {return await res.json();},
	};
};
export const restGetJson = async (url) => {
	const res = await restGet(url);
	return await res.json();
}

export const restPost = async (url, body) => {
	//throw new Error("restPost is deprecated. Use restPost instead.");
	const res = await fetch(
		url,
		{
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: body,
		}
	);
	return {
		status: res.status,
		json: async () => await res.json(),
	};
};
export const restPostJson = async (url, body) => {
	const res = await restPost(url, JSON.stringify(body));
	return await res.json();
}
